import { render, staticRenderFns } from "./newsletterL.vue?vue&type=template&id=5c51a074"
import script from "./newsletterL.vue?vue&type=script&lang=js"
export * from "./newsletterL.vue?vue&type=script&lang=js"
import style0 from "./newsletterL.vue?vue&type=style&index=0&id=5c51a074&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports